// extracted by mini-css-extract-plugin
export default {"HeaderMenuItem":"HeaderMenuItem_HeaderMenuItem__Z4Hsl"};